import type { Sort } from '@/utils/types';

import type { SortMenuOption } from './types';

/** Stable radio value for a given field + direction pair. */
export const buildSortValue = (
  sortBy: string,
  sortOrder: Sort['sort_order']
): string => `${sortBy}__${sortOrder}`;

/** Radio value for an applied `Sort`, or `undefined` when nothing is applied. */
export const buildRadioValue = (sort?: Sort): string | undefined =>
  sort ? buildSortValue(sort.sort_by, sort.sort_order) : undefined;

/** One radio per `SortMenuOption`, in the given order. */
export const buildSortRadioOptions = (options: SortMenuOption[]) =>
  options.map(option => ({
    label: option.label,
    value: buildSortValue(option.sortBy, option.sortOrder)
  }));

/** Maps a radio value back to its `Sort` for the `onSort` callback. */
export const buildSortValueMap = (options: SortMenuOption[]) => {
  const map = new Map<string, Sort>();

  options.forEach(option => {
    map.set(buildSortValue(option.sortBy, option.sortOrder), {
      sort_by: option.sortBy,
      sort_order: option.sortOrder
    });
  });

  return map;
};
